import Vue from 'vue'

export default ({ app }) => {
  Vue.filter('date', (string, format) => {
    return app.$moment(string).format(format || app.i18n.messages[app.i18n.locale].config.date)
  })

  Vue.filter('dateTime', (string, format) => {
    if (!string) return '-'
    return app.$moment(string).format(format || 'DD/MM/YYYY HH:mm')
  })
}
